export default "__VITE_ASSET__mq8oCTGX__"